import React from 'react';
import { SnippetVariable, generateCurlCode } from '../../../utils/schemaSnippets';
import { SyntaxHighlighter } from './SyntaxHighlighter';

export interface CurlSnippetProps {
  variables: SnippetVariable[];
  webhookUrl: string;
  ingestToken: string;
  className?: string;
}

export const CurlSnippet: React.FC<CurlSnippetProps> = ({
  variables,
  webhookUrl,
  ingestToken,
  className = '',
}) => {
  const code = generateCurlCode(webhookUrl, ingestToken, variables);
  return <SyntaxHighlighter code={code} language="bash" className={className} />;
};
